// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__2xSJ0","comment_button":"Timeline_comment_button__2IAsO"};